export default __webpack_public_path__ + "static/media/background.ff6eb412.jpg";